/**
 * @generated SignedSource<<fe98323d8ba25bee0cdc2d21b347b37c>>
 * @relayHash 6ec40e2940a58d5987f8d0d2565b653b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8b009d3de84f25c5f42694160edf048b5c7d1d61a085303179c1eec4658087cc

import type { ConcreteRequest, Query } from 'relay-runtime';
export type chatSimulator_agentIdentityQuery$variables = {
  helpCenterAri: string;
};
export type chatSimulator_agentIdentityQuery$data = {
  readonly csmAi_getAiHubByHelpCenterAri: {
    readonly agent?: {
      readonly conversationStarters?: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly greetingMessage?: string | null | undefined;
      readonly id?: string;
      readonly name?: string | null | undefined;
    } | null | undefined;
    readonly id?: string;
  } | null | undefined;
};
export type chatSimulator_agentIdentityQuery = {
  response: chatSimulator_agentIdentityQuery$data;
  variables: chatSimulator_agentIdentityQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "helpCenterAri"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "name"
},
v4 = {
  "kind": "ScalarField",
  "name": "greetingMessage"
},
v5 = {
  "kind": "ScalarField",
  "name": "message"
},
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "chatSimulator_agentIdentityQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              {
                "kind": "LinkedField",
                "name": "agent",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      {
                        "concreteType": "CsmAiAgentConversationStarter",
                        "kind": "LinkedField",
                        "name": "conversationStarters",
                        "plural": true,
                        "selections": [
                          (v5/*: any*/)
                        ]
                      }
                    ],
                    "type": "CsmAiAgent"
                  }
                ]
              }
            ],
            "type": "CsmAiHub"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "chatSimulator_agentIdentityQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              {
                "kind": "LinkedField",
                "name": "agent",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      {
                        "concreteType": "CsmAiAgentConversationStarter",
                        "kind": "LinkedField",
                        "name": "conversationStarters",
                        "plural": true,
                        "selections": [
                          (v5/*: any*/),
                          (v2/*: any*/)
                        ]
                      }
                    ],
                    "type": "CsmAiAgent"
                  }
                ]
              }
            ],
            "type": "CsmAiHub"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "8b009d3de84f25c5f42694160edf048b5c7d1d61a085303179c1eec4658087cc",
    "metadata": {},
    "name": "chatSimulator_agentIdentityQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "db75ee797c497b47b6a05c1132ca4fc4";

export default node;
